// Single source of truth for legal/compliance data shown in the UI.
export const CONTROLLER = {
    name: "DYNAMIC GROUP S.R.L.S.",
    legalName:
        "DYNAMIC GROUP Società a Responsabilità Limitata Semplificata",
    address: "Via Magenta 31, 50123 Firenze (FI), Italia",
    pec: "dynamic.investiment@pec.it",
    vat: "07282260483",
    fiscalCode: "07282260483",
    rea: "FI - 692606",
    product: "Asta Intelligence",
};

export const LEGAL = {
    privacyVersion: "1.1",
    termsVersion: "1.0",
    cookieVersion: "1.0",
    aiDisclaimerVersion: "1.0",
    updated: "8 luglio 2026",
};

export const LEGAL_LINKS = [
    { to: "/privacy", label: "Privacy Policy" },
    { to: "/termini", label: "Termini e Condizioni" },
    { to: "/cookie", label: "Cookie Policy" },
    { to: "/disclaimer-ai", label: "Disclaimer AI" },
    { to: "/contatti", label: "Contatti" },
];
